export default __webpack_public_path__ + "static/media/pantry1-afterH-1920w.e70204d2.avif";